const intakeFormRoutes = [
	{
		// Интейк из билдера (воронка `ob-kova-intake-form`) — замена живому /telegra.
		// :page — urlSlug экрана, как в воронках (`/glp-app/ob/:page`): рендерер получает его
		// через prop `url`, а мы пушим его на каждом @screen-changed, чтобы работали браузерные
		// Back/Forward и возврат после F5.
		path: '/intake-form/:page(.*)?',
		name: 'intake-form',
		component: () => import(/* webpackChunkName: "intake-form" */ '@/modules/IntakeForm/IntakeFormView.vue'),
		meta: {
			hideHeader: true,
			skipExperiments: true,
			// Аналитика по экранам эмитится внутри IntakeFormView (OnboardingStepShow/Done) —
			// роут-левел мета не нужна. Интейк pre-auth: аккаунта на этом шаге ещё нет (DEV-34805).
		},
	},
]

export default intakeFormRoutes
